// export const fileToBase64 = (file: File): Promise<string> => {
//   return new Promise<string>((resolve, reject) => {
//     const reader = new FileReader()
//     reader.readAsDataURL(file)
//     reader.onload = () => resolve(reader.result?.toString() || '')
//     reader.onerror = error => reject(error)
//   })
// }

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    if (!file) {
      reject(new Error('No file provided'))
      return
    }

    const reader = new FileReader()

    reader.onprogress = event => {
      if (event.lengthComputable) {
        const percentLoaded = Math.round((event.loaded / event.total) * 100)
        console.log(`Progress: ${percentLoaded}%`)
      }
    }

    reader.onload = () => {
      if (reader.result) {
        // Extract the Base64 string from the data URL
        const base64String = reader.result.toString().split(',')[1]
        resolve(base64String)
      } else {
        reject(new Error('Failed to convert file to base64'))
      }
    }

    reader.onerror = error => reject(error)
    reader.readAsDataURL(file)
  })
}
